import latestReleases from '../helpers/versions/latestReleases';

export const getTextBox = () => ({
  object: 'text',
  leaves: [{ text: '' }],
});

export default (params) => {
  const { preTag, sectionKey, componentKey } = params;

  let documentData = {
    selectAll: 0,

    /**
     * Keep updating this version number to latest or
     * if there is a specific version for a specific section overwrite in that block
     */
    version: {
      number: latestReleases[sectionKey] || latestReleases[componentKey],
      updated: true,
    },
  };

  let nodes;
  let data;

  /**
   * Conditionally define the nodes inside skills details
   *
   * * NOTE: Define any new node as a get function, if required
   *
   * * If nodes is common, extract outside of conditions
   */

  if (preTag === 'personal_link') {
    nodes = [getTextBox()];
    documentData = {
      ...documentData,
      selectAll: 1,
    };
    data = {
      ...data,
      url: null,
      organization: 'others',
      toExport: true,
    };
  } else if (preTag === 'publication') {
    nodes = [getTextBox()];
    data = {
      ...data,
      inputType: 'userInput',
      toExport: false,
    };
  } else if (preTag === 'language') {
    nodes = [getTextBox()];
    data = {
      ...data,
      rating: 0,
      maxRating: 5,
      toExport: false,
    };
  } else if (preTag === 'hobbiesAndInterests') {
    nodes = [getTextBox()];
    data = {
      ...data,
      toExport: false,
    };
  }

  return {
    document: {
      data: documentData,
      nodes: [
        {
          object: 'block',
          type: preTag,
          data,
          nodes,
        },
      ],
    },
  };
};
